const ENJUPHOTOS_URL = window.__ENJOEI_ENJUPHOTOS_URL__ || 'https://photos.enjoei.com.br'
const ENJUPHOTOS_SLUG = 'public'

export const ENJUPHOTOS_PRESETS = {
  product: {
    card: '240x240',
    small_card: '50x50',
    help_card: '100x100',
    help_card2x: '200x200',
    metaProduct: '1200x1200',
    slot: '90x108'
  },
  user: {
    avatar: '50x50',
    avatar2x: '100x100',
    bigAvatar: '150x150'
  },
  userStore: {
    header: '1176x200',
    avatar: '100x100',
    avatar2x: '200x200',
    metaAvatar: '576x500'
  },
  contentWidget: {
    card: '500x500'
  },
  gallery: {
    desktop: '828xN',
    desktop_magnified: '1200xN',
    thumb: '100x100',
    thumb2x: '200x200',
    mobile: '800x800'
  },
  homePickup: {
    productCard: '180x180',
    bundleProductCard: '90x90'
  }
}

export function getImageUrl(imagePublicId, preset, slug) {
  return `${ENJUPHOTOS_URL}/${slug ? slug : ENJUPHOTOS_SLUG}/${preset}/${imagePublicId}`
}
